import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';
import cookie from './modules/cookie';
import dicts from './modules/dicts';
import division from './modules/division';
import file from './modules/file';
import user from './modules/user';
import notify from './modules/notify';

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        common,
        cookie,
        dicts,
        division,
        file,
        user,
        notify
    },

    strict: debug
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js